package pl.nickers.match3.ui

import kotlinproject.composeapp.generated.resources.Res
import kotlinproject.composeapp.generated.resources.bomb
import kotlinproject.composeapp.generated.resources.bomb_face_1
import kotlinproject.composeapp.generated.resources.bomb_face_2
import kotlinproject.composeapp.generated.resources.cross_bomb
import kotlinproject.composeapp.generated.resources.face_1
import kotlinproject.composeapp.generated.resources.face_2
import kotlinproject.composeapp.generated.resources.face_3
import kotlinproject.composeapp.generated.resources.face_4
import kotlinproject.composeapp.generated.resources.face_5
import kotlinproject.composeapp.generated.resources.face_6
import kotlinproject.composeapp.generated.resources.ice_1
import kotlinproject.composeapp.generated.resources.ice_2
import kotlinproject.composeapp.generated.resources.ice_3
import kotlinproject.composeapp.generated.resources.jelly_1
import kotlinproject.composeapp.generated.resources.jelly_2
import kotlinproject.composeapp.generated.resources.jelly_3
import kotlinproject.composeapp.generated.resources.jelly_4
import kotlinproject.composeapp.generated.resources.jelly_5
import kotlinproject.composeapp.generated.resources.jelly_6
import kotlinproject.composeapp.generated.resources.laser
import kotlinproject.composeapp.generated.resources.swirl
import org.jetbrains.compose.resources.DrawableResource

private val bodyDrawables = mapOf(
    "jelly_1.png" to Res.drawable.jelly_1,
    "jelly_2.png" to Res.drawable.jelly_2,
    "jelly_3.png" to Res.drawable.jelly_3,
    "jelly_4.png" to Res.drawable.jelly_4,
    "jelly_5.png" to Res.drawable.jelly_5,
    "jelly_6.png" to Res.drawable.jelly_6,
    "bomb.png" to Res.drawable.bomb,
    "ice_1.png" to Res.drawable.ice_1,
    "ice_2.png" to Res.drawable.ice_2,
    "ice_3.png" to Res.drawable.ice_3,
    "laser.png" to Res.drawable.laser,
    "swirl.png" to Res.drawable.swirl,
    "cross_bomb.png" to Res.drawable.cross_bomb,
)

private val faceDrawables = mapOf(
    "face_1.png" to Res.drawable.face_1,
    "face_2.png" to Res.drawable.face_2,
    "face_3.png" to Res.drawable.face_3,
    "face_4.png" to Res.drawable.face_4,
    "face_5.png" to Res.drawable.face_5,
    "face_6.png" to Res.drawable.face_6,
    "bomb_face_1.png" to Res.drawable.bomb_face_1,
    "bomb_face_2.png" to Res.drawable.bomb_face_2,
    // Special tiles carry their character in the body art; faces stay blank overlays.
    "laser_face.png" to Res.drawable.bomb_face_1,
    "swirl_face.png" to Res.drawable.bomb_face_2,
)


internal fun String.toBodyDrawableRes(): DrawableResource =
    bodyDrawables[this] ?: Res.drawable.jelly_1

internal fun String.toFaceDrawableRes(): DrawableResource =
    faceDrawables[this] ?: Res.drawable.face_1

